import Mobile from '../assets/johnonphone.webp';
import SignUpBtn from '../resuable-components/Button';
import { trackSignupEvent } from '../../../utlis/useAnalytics'; 
export default function Endcta() {
  const btnClick = () => {
    trackSignupEvent( {
      page: 'Global Trade Page',
      section: 'End Cta SignUp',
    });
  };

  return (
    <div className="text-[#1A202C] flex flex-col md:flex-row justify-between items-center px-4 md:px-8 lg:px-[15%] mt-[140px] w-full box-border">
      <div className="text-center md:text-left mb-8 md:mb-0 w-full md:w-1/2 box-border px-0 md:px-4">
        <p className="font-bold text-2xl md:text-3xl font-inter">
          Change the way you manage your EXIM business​
        </p>
        <SignUpBtn onClick={btnClick} />
      </div>
      <div className="w-full md:w-1/2 flex ml-8 lg:mr-[-15%] justify-center items-center box-border px-0 md:px-4">
        <img
          src={Mobile}
          alt="Demo Illustration"
          className="hover:scale-[105%] transition-transform duration-300 w-100 max-w-[500px]"
        />
      </div>
    </div>
  );
}
